import { UserRole } from '~~/shared/interfaces/profile';

namespace RouterNameSpace {
	export const routerRedirectIsLoggedIn = '/cargos';
	export const routerRedirectNoLoggedIn = '/authorization/sign-in';
}

const roleHomePageRedirectExceptions: { role: UserRole; path: RegExp }[] = [
	{ role: UserRole.Trucker, path: /^\/trucker\/[^/]+$/ }
];

export const shouldSkipRoleHomePageRedirect = (role: UserRole | undefined, path: string): boolean =>
	role !== undefined &&
	roleHomePageRedirectExceptions.some((exception) => exception.role === role && exception.path.test(path));

export default RouterNameSpace;
